import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import analysisReducer from '../features/analysis/AnalysisSlice'
import chatConvReducer from '../features/chat/ChatConvSlice'
import authReducer from '../features/auth/AuthSlice'
import bulkUploadrReducer from '../features/bulk-upload/BulkUploadrSlice'
import adminReducer from '../features/admin/AdminSlice'
import adminUserReducer from '../features/admin-user/AdminUserSlice'
import adminOrgReducer from '../features/admin-org/AdminOrgSlice'
import adminStripeReducer from '../features/admin-stripe/AdminStripeSlice'
import slugReducer from '../features/slugs/SlugSlice'
import apiTokenReducer from '../features/api-token/ApiTokenSlice'
import gcloudTokenReducer from '../features/api-token/GcloudTokenSlice'
import customizeReducer from '../features/customize/CustomizeSlice'
import inviteReducer from '../features/invite/InviteSlice'

export const store = configureStore({
  reducer: {
    analysis: analysisReducer,
    auth: authReducer,
    admin: adminReducer,
    adminUser: adminUserReducer,
    adminOrg: adminOrgReducer,
    adminStripe: adminStripeReducer,
    chatConv: chatConvReducer,
    bulkUploadr: bulkUploadrReducer,
    slugs: slugReducer,
    apiToken: apiTokenReducer,
    gcloudToken: gcloudTokenReducer,
    customize: customizeReducer,
    invite: inviteReducer,
  },
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
